import React from 'react';
import { Shield, BookOpen, Heart, Eye } from 'lucide-react';
import { siteContent } from '../data/mock';

const CredibilitySection = () => {
  const { credibility } = siteContent;
  const icons = [BookOpen, Shield, Heart, Eye];

  return (
    <section className="credibility-section section-padding" data-testid="credibility-section">
      <div className="container">
        <h2 className="section-title-center" data-testid="credibility-title">{credibility.title}</h2>
        <p className="credibility-introduction">{credibility.introduction}</p>

        <div className="credibility-grid">
          {credibility.points.map((point, index) => {
            const Icon = icons[index];
            return (
              <div key={index} className="content-card credibility-card" data-testid={`credibility-card-${index}`}>
                <div className="credibility-icon">
                  <Icon size={32} strokeWidth={1.5} />
                </div>
                <h3 className="credibility-title-card">{point.title}</h3>
                <p className="credibility-description">{point.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
